/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateJobLabelRequestBody,
  CreateJobLabelResponse,
  GetJobLabelResponse,
  GetJobLabelsParams,
  GetJobLabelsResponse,
  UpdateJobLabelRequestBody,
  UpdateJobLabelResponse
} from '../model';

import postJobLabelMutator from '../../../mutators/datastore-instance';
import getJobLabelsMutator from '../../../mutators/datastore-instance';
import getJobLabelMutator from '../../../mutators/datastore-instance';
import putJobLabelMutator from '../../../mutators/datastore-instance';
import deleteJobLabelMutator from '../../../mutators/datastore-instance';



  /**
 * JobLabelを新規作成する
 * @summary JobLabelを新規作成
 */
export const postJobLabel = (
    createJobLabelRequestBody?: CreateJobLabelRequestBody,
 ) => {
      return postJobLabelMutator<CreateJobLabelResponse>(
      {url: `/job-labels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createJobLabelRequestBody
    },
      );
    }
  /**
 * JobLabelを一覧取得・検索をする
 * @summary JobLabelの一覧・検索
 */
export const getJobLabels = (
    params?: GetJobLabelsParams,
 ) => {
      return getJobLabelsMutator<GetJobLabelsResponse>(
      {url: `/job-labels`, method: 'GET',
        params
    },
      );
    }
  /**
 * JobLabelの詳細を取得する
 * @summary JobLabel の詳細取得
 */
export const getJobLabel = (
    jobLabelId: number,
 ) => {
      return getJobLabelMutator<GetJobLabelResponse>(
      {url: `/job-labels/${jobLabelId}`, method: 'GET'
    },
      );
    }
  /**
 * JobLabel を更新する
 * @summary JobLabel の更新
 */
export const putJobLabel = (
    jobLabelId: number,
    updateJobLabelRequestBody?: UpdateJobLabelRequestBody,
 ) => {
      return putJobLabelMutator<UpdateJobLabelResponse>(
      {url: `/job-labels/${jobLabelId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateJobLabelRequestBody
    },
      );
    }
  /**
 * JobLabel を削除する
 * @summary JobLabel の削除
 */
export const deleteJobLabel = (
    jobLabelId: number,
 ) => {
      return deleteJobLabelMutator<void>(
      {url: `/job-labels/${jobLabelId}`, method: 'DELETE'
    },
      );
    }
  export type PostJobLabelResult = NonNullable<Awaited<ReturnType<typeof postJobLabel>>>
export type GetJobLabelsResult = NonNullable<Awaited<ReturnType<typeof getJobLabels>>>
export type GetJobLabelResult = NonNullable<Awaited<ReturnType<typeof getJobLabel>>>
export type PutJobLabelResult = NonNullable<Awaited<ReturnType<typeof putJobLabel>>>
export type DeleteJobLabelResult = NonNullable<Awaited<ReturnType<typeof deleteJobLabel>>>
